function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgDr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2500,
    height: 2500
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A6A6A6"
    },
    d: "M2310.684,801.882c-57.986-137.092-140.979-260.196-246.675-365.892 c-105.697-105.696-228.801-188.689-365.892-246.674c-141.976-60.051-292.745-90.5-448.117-90.5 c-155.372,0-306.141,30.449-448.118,90.5C664.79,247.301,541.686,330.294,435.99,435.991S247.301,664.79,189.316,801.882 c-60.051,141.977-90.5,292.745-90.5,448.118c0,155.373,30.449,306.141,90.5,448.117 c57.985,137.092,140.978,260.196,246.674,365.892c23.582,23.582,48.037,46.026,73.315,67.323l23.968-79.555 c20.283-78.807,53.323-153.331,98.2-221.501c44.107-67.001,98.482-126.126,161.614-175.735 c63.791-50.126,134.784-89.154,211.008-116c78.864-27.776,161.598-41.859,245.904-41.859c84.307,0,167.041,14.084,245.905,41.859 c76.224,26.846,147.217,65.874,211.007,116c63.132,49.609,117.507,108.734,161.614,175.735 c44.877,68.171,77.918,142.694,98.2,221.501l21.524,81.596c26.145-21.904,51.419-45.024,75.759-69.364 c105.696-105.697,188.689-228.801,246.675-365.892c60.05-141.976,90.499-292.745,90.499-448.117 C2401.183,1094.627,2370.734,943.859,2310.684,801.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M1966.726,2051.777c-20.283-78.807-53.323-153.331-98.2-221.501 c-44.107-67.001-98.482-126.126-161.614-175.735c-63.791-50.126-134.783-89.154-211.007-116 c-78.864-27.776-161.598-41.859-245.905-41.859c-84.306,0-167.041,14.084-245.904,41.859 c-76.224,26.846-147.217,65.874-211.008,116c-63.132,49.609-117.507,108.734-161.614,175.735 c-44.878,68.171-77.917,142.694-98.2,221.501l-23.968,79.555c11.728,9.881,23.64,19.504,35.721,28.885 c78.584,61.02,164.543,111.422,256.856,150.468c141.977,60.05,292.745,90.499,448.118,90.499 c155.373,0,306.141-30.449,448.117-90.499c99.911-42.259,192.382-97.816,276.11-165.748c4.702-3.815,9.376-7.67,14.023-11.563 L1966.726,2051.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M1628.793,1089.942c-20.712-48.968-50.344-92.928-88.075-130.659 c-37.732-37.732-81.693-67.365-130.66-88.076c-50.74-21.461-104.592-32.343-160.059-32.343s-109.318,10.882-160.058,32.343 c-48.968,20.711-92.928,50.344-130.659,88.076s-67.365,81.692-88.076,130.659c-21.461,50.74-32.343,104.591-32.343,160.058 s10.882,109.318,32.343,160.059c20.711,48.967,50.344,92.927,88.076,130.66c37.732,37.731,81.692,67.364,130.659,88.075 c50.74,21.462,104.591,32.343,160.058,32.343s109.318-10.881,160.059-32.343c48.967-20.712,92.927-50.344,130.66-88.075 c37.731-37.732,67.364-81.693,88.075-130.66c21.462-50.74,32.343-104.592,32.343-160.059S1650.256,1140.682,1628.793,1089.942z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgDr);
export default __webpack_public_path__ + "static/media/svgDr.05b9a0302d2e2a684946d13fe736597e.svg";
export { ForwardRef as ReactComponent };